/**
 * Create the store with dynamic reducers
 */

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { accountsService, api } from 'services';

const rootReducer = combineReducers({
  [accountsService.reducerPath]: accountsService.reducer,
  [api.reducerPath]: api.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export function configureAppStore(preloadedState: Partial<RootState> = {}) {
  const store = configureStore({
    reducer: rootReducer,
    devTools: import.meta.env.MODE !== 'production',
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(accountsService.middleware, api.middleware),
  });

  return store;
}

export const store = configureAppStore();
